module.exports = __webpack_public_path__ + "img/p4.2adb2c1.png";